// extracted by mini-css-extract-plugin
export default {"BannerContainer":"advertisement_BannerContainer__M-Jyk","MobileBannerContainer":"advertisement_MobileBannerContainer__J86KW"};